import MapCard from "../../../../../common/cards/MapCard/MapCard";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Typography,
  Upload,
  Checkbox,
  TimePicker
} from "antd";
import NameAndType from "../NameAndType/index";
import moment from "moment";
import React, { useEffect, useState } from "react";
import useVariables from "../../../../../common/hooks/useVariables";
import { GetPanelsOfOwner as GetPanelsOfOwnerApi } from "../../../../../Config/API/panel";
import InputTextField from "../../../../../common/FormItem/InputTextField";
import ChooseAwardsModal from "./ChooseAwardsModal";
import ChoosePanelModal from "./ChoosePanelModal";
import { UploadOutlined } from "@ant-design/icons";
import {
  EVENT_TYPES,
  GAMES_MODES,
  TOURNAMENT_TYPES_LIST
} from "../../../../../Config/helpers/constants";
import { FieldArray } from "formik";
import { MdDelete } from "react-icons/md";

import { error } from "../../../../../common/Alerts/Message";
import { useParams } from "react-router-dom";
import { LOCATIONS } from "../../../../../Config/helpers/constants";

const { RangePicker } = DatePicker;
const { Option } = Select;

function Page1({
  panelModal,
  setPanelModal,
  isVisible,
  setFieldValue,
  touched,
  setFieldTouched,
  values,
  errors,
  sportAwards,
  setSportAwards,
  registrationComplete
}) {
  const [panels, setPanels] = useState(null);
  const [awardsOpen, setAwardsOpen] = useState(false);
  const { viewer } = useVariables();
  const { eventID } = useParams();
  const data = { name: "", registrationFee: "", noOfSlots: 1 };

  const fetchPanelData = async () => {
    const id = viewer?.id;
    if (id) {
      try {
        const response = await GetPanelsOfOwnerApi(id);
        const data = await response.json();
        if (data.type === "success") {
          const filterData = data?.result?.map((panel) => {
            return {
              value: panel._id,
              label: panel.name
            };
          });
          setPanels(filterData);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    if (viewer?.id && !eventID) {
      setPanelModal(true);
    }

    if (viewer?.id) {
      fetchPanelData();
    }
  }, [viewer?.id, eventID]);

  const children = [];
  for (let i = 10; i < 12; i++) {
    children.push(<Option key={i}>{i.toString(12) + i}</Option>);
  }

  const setCoordinates = (value) => {
    setFieldValue("coordinates", value);
  };

  const setLocation = (value) => {
    setFieldValue("location", value);
  };

  const setStartEndDate = (dateString) => {
    setFieldValue("startDate", dateString[0]);
    setFieldValue("endDate", dateString[1]);
  };

  const isEsportsPubg = () => {
    return values?.selectedSport?.toLowerCase() === "pubg";
  };

  const isScrimMode = () => {
    return values?.type === EVENT_TYPES.SCRIM;
  };

  const isValidScrimDateTime = (eventDate, eventTime, deadlineDate, deadlineTime) => {
    if (!eventDate || !deadlineDate) return true;

    const eventMoment = moment(eventDate);
    const deadlineMoment = moment(deadlineDate);

    if (!eventMoment.isSame(deadlineMoment, "day")) {
      return eventMoment.isAfter(deadlineMoment, "day");
    }

    if (eventTime && deadlineTime) {
      const eventTimeMoment = moment(eventTime, "hh:mm a");
      const deadlineTimeMoment = moment(deadlineTime, "hh:mm a");
      return eventTimeMoment.isAfter(deadlineTimeMoment);
    }

    return true;
  };

  if (!isVisible) return null;

  return (
    <>
      <Row style={{ paddingBottom: "6%" }}>
        <Col lg={12} md={12} className="ceinputformpadding">
          {/* event name */}
          <InputTextField
            name="name"
            label="Name of Event"
            required
            placeholder="e.g   “ Spartans Club “"
            className={"profileItems"}
            disabled={values?.sponsor?._id}
          />

          {/* event description */}
          <InputTextField
            name="description"
            label="Description"
            placeholder="e.g   “ Cyberpunks FTS Collectibles “"
            className={"profileItems"}
          />

          {/* select game and game type */}
          <NameAndType
            setFieldValue={setFieldValue}
            values={values}
            errors={errors}
            isEdit={eventID && !values?.draft ? true : false}
          />

          {isEsportsPubg() && (
            <Form.Item
              className="profileItems"
              help={touched?.type && errors?.type ? errors?.type : undefined}
              validateStatus={touched?.type && errors?.type ? "error" : "success"}>
              <label className="boldlabel required">Event Type</label>
              <Select
                value={values?.type}
                placeholder={"Select Event Type"}
                className="ceinputfieldnos"
                onChange={(e) => {
                  setFieldValue("type", e);

                  if (e === EVENT_TYPES.SCRIM) {
                    setFieldValue("location", "");
                    setFieldValue("city", "");
                    setFieldValue("coordinates", "");
                    setFieldValue("endDate", "");
                    setFieldValue("wildCardEntry", false);
                    setFieldValue("wildCard", []);
                  }
                }}
                onBlur={() => setFieldTouched("type", true)}
                disabled={eventID && !values?.draft}>
                <Option value={EVENT_TYPES.TOURNAMENT}>Tournament</Option>
                <Option value={EVENT_TYPES.SCRIM}>Scrim</Option>
              </Select>
            </Form.Item>
          )}

          <Form.Item
            className="halfwidth profileItems"
            help={touched?.deadLineDate && errors?.deadLineDate ? errors?.deadLineDate : undefined}
            validateStatus={touched?.deadLineDate && errors?.deadLineDate ? "error" : "success"}>
            <label className="boldlabel required">Registration Deadline</label>
            <div style={{ display: "flex", gap: "10px" }}>
              <DatePicker
                disabledDate={(current) => {
                  return current && current < moment().add(-1, "day");
                }}
                disabled={registrationComplete}
                inputReadOnly
                className="profileItems"
                value={values?.deadLineDate ? moment(values?.deadLineDate) : undefined}
                onChange={(_e, formatted) => {
                  setFieldValue("deadLineDate", formatted);
                  if (isScrimMode()) {
                    // For scrim, only clear if event date is before new deadline date
                    if (
                      values?.startDate &&
                      moment(values?.startDate).isBefore(moment(formatted), "day")
                    ) {
                      setFieldValue("startDate", "");
                      setFieldValue("startTime", "");
                    }
                  } else {
                    // For tournament, keep existing logic
                    if (
                      values?.startDate &&
                      moment(values?.startDate).isSameOrBefore(moment(formatted))
                    ) {
                      setFieldValue("startDate", "");
                      setFieldValue("endDate", "");
                    }
                  }
                }}
                onBlur={() => setFieldTouched("deadLineDate", true)}
              />
              {isScrimMode() && (
                <TimePicker
                  format="hh:mm a"
                  value={values?.deadlineTime ? moment(values?.deadlineTime, "hh:mm a") : undefined}
                  onChange={(time, timeString) => {
                    setFieldValue("deadlineTime", timeString);
                    // Clear event time if it's now invalid
                    if (
                      values?.startDate &&
                      values?.startTime &&
                      values?.deadLineDate &&
                      moment(values?.startDate).isSame(moment(values?.deadLineDate), "day") &&
                      timeString &&
                      moment(values?.startTime, "hh:mm a").isSameOrBefore(
                        moment(timeString, "hh:mm a")
                      )
                    ) {
                      setFieldValue("startTime", "");
                    }
                  }}
                  onBlur={() => setFieldTouched("deadlineTime", true)}
                  placeholder="Select time"
                  className="profileItems"
                />
              )}
            </div>
          </Form.Item>

          {isScrimMode() ? (
            <Form.Item
              className="profileItems"
              help={touched?.startDate && errors?.startDate ? errors?.startDate : undefined}
              validateStatus={touched?.startDate && errors?.startDate ? "error" : "success"}>
              <label className="boldlabel required">Event Date & Time</label>
              <div style={{ display: "flex", gap: "10px" }}>
                <DatePicker
                  disabled={registrationComplete || !values?.deadLineDate}
                  inputReadOnly
                  disabledDate={(current) => {
                    if (current && current < moment().add(-1, "day")) {
                      return true;
                    }
                    if (values?.deadLineDate && current) {
                      // For scrim, allow same day as deadline, but not before deadline date
                      return current.isBefore(moment(values?.deadLineDate), "day");
                    }
                    return false;
                  }}
                  value={values?.startDate ? moment(values?.startDate) : null}
                  onChange={(_e, dateString) => {
                    setFieldValue("startDate", dateString);
                    // Clear event time if date changed and time validation might be affected
                    if (
                      values?.startTime &&
                      values?.deadLineDate &&
                      values?.deadlineTime &&
                      moment(dateString).isSame(moment(values?.deadLineDate), "day")
                    ) {
                      // Check if current time is still valid for the new date
                      if (
                        moment(values?.startTime, "hh:mm a").isSameOrBefore(
                          moment(values?.deadlineTime, "hh:mm a")
                        )
                      ) {
                        setFieldValue("startTime", "");
                      }
                    }
                  }}
                  onBlur={() => setFieldTouched("startDate", true)}
                  placeholder="Event Date"
                  style={{ flex: 1 }}
                />
                <TimePicker
                  format="hh:mm a"
                  value={values?.startTime ? moment(values?.startTime, "hh:mm a") : undefined}
                  onChange={(time, timeString) => {
                    setFieldValue("startTime", timeString);
                  }}
                  onBlur={() => setFieldTouched("startTime", true)}
                  placeholder="Event time"
                  style={{ width: "120px" }}
                  disabledTime={() => {
                    // Disable times only if event is on same day as deadline
                    if (
                      values?.startDate &&
                      values?.deadLineDate &&
                      values?.deadlineTime &&
                      moment(values?.startDate).isSame(moment(values?.deadLineDate), "day")
                    ) {
                      const deadlineTime = moment(values?.deadlineTime, "hh:mm a");
                      return {
                        disabledHours: () => {
                          const hours = [];
                          for (let i = 0; i < deadlineTime.hour(); i++) {
                            hours.push(i);
                          }
                          return hours;
                        },
                        disabledMinutes: (selectedHour) => {
                          if (selectedHour === deadlineTime.hour()) {
                            const minutes = [];
                            for (let i = 0; i <= deadlineTime.minute(); i++) {
                              minutes.push(i);
                            }
                            return minutes;
                          }
                          return [];
                        }
                      };
                    }
                    return {};
                  }}
                />
              </div>
              {!values?.deadLineDate && (
                <div style={{ color: "#ff4d4f", fontSize: "12px", marginTop: "4px" }}>
                  Please select registration deadline first
                </div>
              )}
              {/* Additional validation message for scrim time */}
              {isScrimMode() &&
                values?.startDate &&
                values?.deadLineDate &&
                values?.startTime &&
                values?.deadlineTime &&
                moment(values?.startDate).isSame(moment(values?.deadLineDate), "day") &&
                !isValidScrimDateTime(
                  values?.startDate,
                  values?.startTime,
                  values?.deadLineDate,
                  values?.deadlineTime
                ) && (
                  <div style={{ color: "#ff4d4f", fontSize: "12px", marginTop: "4px" }}>
                    Event time must be after registration deadline time on the same day
                  </div>
                )}
            </Form.Item>
          ) : (
            <Form.Item
              className="profileItems"
              help={
                (touched?.startDate && errors?.startDate) || (touched?.endDate && errors?.endDate)
                  ? errors?.startDate || errors?.endDate
                  : undefined
              }
              validateStatus={
                (touched?.startDate && errors?.startDate) || (touched?.endDate && errors?.endDate)
                  ? "error"
                  : ""
              }>
              <label className="boldlabel required">Start Date and End Date</label>
              <RangePicker
                disabled={registrationComplete || !values?.deadLineDate}
                inputReadOnly
                disabledDate={(current) => {
                  if (current && current < moment().add(-1, "day")) {
                    return true;
                  }
                  if (
                    values?.deadLineDate &&
                    current &&
                    current.isBefore(moment(values?.deadLineDate).add(1, "day"))
                  ) {
                    return true;
                  }
                  return false;
                }}
                style={{ maxWidth: "240px" }}
                value={[
                  values?.startDate ? moment(values?.startDate) : null,
                  values?.endDate ? moment(values?.endDate) : null
                ]}
                onChange={(_e, dateString) => {
                  setStartEndDate(dateString);
                }}
                onBlur={() => {
                  setFieldTouched("startDate", true);
                  setFieldTouched("endDate", true);
                }}
                placeholder={["Start Date", "End Date"]}
              />
              {!values?.deadLineDate && (
                <div style={{ color: "#ff4d4f", fontSize: "12px", marginTop: "4px" }}>
                  Please select registration deadline first
                </div>
              )}
            </Form.Item>
          )}

          <InputTextField
            required
            type="textArea"
            label="Rules and regulation"
            name="rules"
            rows="5"
          />
          <Form.Item label="Rules and regulation file" name="rulesFile">
            <Upload
              accept=".pdf,.docx"
              maxCount={1}
              beforeUpload={() => {
                return false;
              }}
              onChange={({ file }) => {
                if (file.status === "removed") {
                  return; // Don't do anything if the file is being removed
                }
                setFieldValue("rulesFile", { file: file.originFileObj || file });
              }}
              onRemove={() => {
                setFieldValue("rulesFile", null);
                return true;
              }}>
              <Button icon={<UploadOutlined />}>Click to Upload PDF/DOCX</Button>
            </Upload>
          </Form.Item>
        </Col>

        <Col md={12} lg={12} className="ceinputformpadding">
          <Form.Item
            className="profileItems"
            help={touched?.panel && errors?.panel ? errors?.panel : undefined}
            validateStatus={touched?.panel && errors?.panel ? "error" : "success"}>
            <label className="boldlabel">Select Panel</label>
            <Select
              disabled={values?.sponsor?._id}
              value={values?.panel}
              placeholder={"Select Panel"}
              className="ceinputfieldnos"
              onChange={(e) => setFieldValue("panel", e)}
              onBlur={() => setFieldTouched("panel", true)}
              options={panels?.length > 0 ? panels : ""}
            />
          </Form.Item>

          {/* location */}
          {!isScrimMode() && (
            <Form.Item
              className="profileItems"
              style={{ marginBottom: "0px" }}
              help={errors?.location ? errors?.location : undefined}
              validateStatus={errors?.location ? "error" : "success"}>
              <label className="boldlabel required">Location</label>
              <MapCard
                padding
                setCoordinate={setCoordinates}
                setLocation={setLocation}
                data={{ coordinate: values?.coordinates }}
              />
              <Input
                name="location"
                style={{ marginBottom: "30px" }}
                onChange={(e) => setFieldValue("location", e.target.value)}
                value={values?.location}
                placeholder="e.g Islamabad"
              />
              <Form.Item
                className="halfwidth profileItems"
                help={touched?.city && errors?.city ? errors?.city : undefined}
                validateStatus={touched?.city && errors?.city ? "error" : "success"}>
                <label className="boldlabel required">Select City</label>
                <Select
                  value={values?.city}
                  placeholder={"Select city"}
                  className="ceinputfieldnos"
                  onChange={(e) => setFieldValue("city", e)}
                  onBlur={() => setFieldTouched("city", true)}
                  options={LOCATIONS?.length > 0 ? LOCATIONS : []}
                />
              </Form.Item>
            </Form.Item>
          )}

          {/* Fee */}
          <Form.Item
            className=" profileItems"
            help={touched?.fee && errors?.fee ? errors?.fee : undefined}
            validateStatus={touched?.fee && errors?.fee ? "error" : "success"}>
            <label className="boldlabel">Registration Fees</label>
            <InputNumber
              name="fee"
              value={values?.fee}
              onChange={(e) => setFieldValue("fee", e)}
              onBlur={() => setFieldTouched("fee", true)}
              style={{ width: "200px" }}
            />
          </Form.Item>

          <Form.Item
            className=" profileItems halfwidth"
            help={touched?.awards && errors?.awards ? errors?.awards : undefined}
            validateStatus={errors?.awards ? "error" : "success"}>
            <label className="boldlabel required">Awards and Prizes</label>
            <Button
              onClick={() => {
                if (values?.selectedSport?.length > 0) {
                  setAwardsOpen(true);
                } else {
                  error("Choose sports firsts");
                }
              }}>
              {values?.awards?.length > 0 ? "Update Awards" : "Choose Awards"}
            </Button>
          </Form.Item>

          <section>
            {values?.awards?.length > 0 ? (
              <ol>
                {values?.awards?.map((award, index) => (
                  <React.Fragment key={index}>
                    <li>
                      {sportAwards?.find((itemAward) => itemAward?._id === award?.awardId)?.title ||
                        "-"}
                    </li>
                    <ul>
                      {award?.awards?.map((subAward, subIndex) => (
                        <li key={subIndex}>
                          <Typography.Text type="success">
                            Rank : {subAward?.rank} :{" "}
                          </Typography.Text>
                          <Typography.Text type="secondary">
                            Award Type: {subAward?.awardType}{" "}
                            {subAward?.type === "cash" ? ":" : null}
                          </Typography.Text>
                          {subAward?.awardType === "cash" && (
                            <Typography.Text type="warning">
                              Value:{subAward?.awardValue}
                            </Typography.Text>
                          )}
                        </li>
                      ))}
                    </ul>
                  </React.Fragment>
                ))}
              </ol>
            ) : (
              ""
            )}
          </section>

          <Form.Item
            className="halfwidth profileItems"
            help={touched?.typeOfMatch && errors?.typeOfMatch ? errors?.typeOfMatch : undefined}
            validateStatus={errors?.typeOfMatch ? "error" : "success"}>
            <label className="boldlabel required">Type of Match Schedule</label>
            <Select
              className="ceinputfieldnos"
              title="league"
              onChange={(e) => {
                setFieldValue("typeOfMatch", e);
              }}
              onBlur={() => setFieldTouched("typeOfMatch", true)}
              value={values?.typeOfMatch}
              bordered={true}
              disabled={eventID && !values?.draft ? true : false}>
              {values?.gameMode === GAMES_MODES.multi ? (
                <>
                  <Option value={GAMES_MODES.multi}>Multiplayer</Option>
                </>
              ) : (
                <>
                  {TOURNAMENT_TYPES_LIST.map((game, index) => (
                    <Option key={index} value={game.value}>
                      {game.label}
                    </Option>
                  ))}
                </>
              )}
            </Select>
          </Form.Item>

          <Form.Item
            className="halfwidth profileItems"
            help={
              (touched?.maxParticipants && errors?.maxParticipants) ||
              (touched?.minParticipants && errors?.minParticipants)
                ? errors?.maxParticipants || errors?.minParticipants
                : undefined
            }
            validateStatus={
              (touched?.maxParticipants && errors?.maxParticipants) ||
              (touched?.minParticipants && errors?.minParticipants)
                ? "error"
                : "success"
            }>
            <label className="boldlabel required">Max/Min Number of Participants</label>
            <div
              className="cemaxinput"
              style={{
                justifyContent: "flex-start",
                gap: "10px",
                marginTop: "20px"
              }}>
              <div>
                <label className="boldlabel" style={{ fontSize: "14px" }}>
                  MAX
                </label>
              </div>
              <div>
                <Input
                  onChange={(e) => {
                    if (!Number(e?.currentTarget?.value)) return;
                    let num = e?.currentTarget?.value;
                    if (num && num > 0) setFieldValue("maxParticipants", Math.abs(num));
                    e.target.onkeydown = (a) => {
                      if (a.key === "Backspace" && e?.target?.value?.length === 1) {
                        setFieldValue("maxParticipants", null);
                      }
                    };
                  }}
                  onBlur={() => setFieldTouched("maxParticipants", true)}
                  value={values?.maxParticipants}
                  style={{
                    maxWidth: "75px",
                    maxHeight: "33px",
                    marginTop: "0",
                    borderRadius: "8px",
                    marginRight: "25px"
                  }}
                  type="number"
                  className="ceinputfield"
                />
              </div>
              <div>
                <label className="boldlabel" style={{ fontSize: "14px" }}>
                  MIN
                </label>
              </div>
              <div>
                <Input
                  onChange={(e) => {
                    if (!Number(e?.target?.value)) return;
                    let num = e?.currentTarget?.value;
                    if (num && num > 0) setFieldValue("minParticipants", Math.abs(num));
                    e.target.onkeydown = (a) => {
                      if (a.key === "Backspace" && e?.target?.value?.length === 1) {
                        setFieldValue("minParticipants", undefined);
                      }
                    };
                  }}
                  onBlur={() => setFieldTouched("minParticipants", true)}
                  disabled={eventID && !values?.draft ? true : false}
                  value={values?.minParticipants}
                  style={{
                    maxWidth: "75px",
                    maxHeight: "33px",
                    marginTop: "0",
                    borderRadius: "8px"
                  }}
                  type="number"
                  className="ceinputfielddesc"
                />
              </div>
            </div>
          </Form.Item>

          {!isScrimMode() && (
            <>
              <Form.Item className="profileItems">
                <Checkbox
                  onChange={(e) => setFieldValue("wildCardEntry", e.target.checked)}
                  value={values?.wildCardEntry}
                  checked={values?.wildCardEntry}>
                  <span className="boldlabel">Wild Card Entry</span>
                </Checkbox>
                {typeof errors?.wildCard === "string" && (
                  <div className="customError" style={{ marginTop: "8px", color: "#ff4d4f" }}>
                    {errors?.wildCard}
                  </div>
                )}
              </Form.Item>

              {values?.wildCardEntry && (
                <Form.Item className="profileItems">
                  <FieldArray
                    name="wildCard"
                    render={(arrayHelpers) => (
                      <div>
                        {values.wildCard &&
                          values.wildCard.length > 0 &&
                          values.wildCard.map((card, index) => {
                            if (card?._id && card?.isDeleted) {
                              return null;
                            }
                            return (
                              <div key={index} className="wildcard-item">
                                <Row gutter={16} align="top">
                                  <Col xs={24} sm={12} md={8}>
                                    <Form.Item
                                      className="profileItems"
                                      help={errors?.wildCard?.[index]?.name}
                                      validateStatus={
                                        errors?.wildCard?.[index]?.name ? "error" : "success"
                                      }
                                      style={{ marginBottom: "16px" }}>
                                      <label className="boldlabel">Wild Card Name</label>
                                      <Input
                                        name={`wildCard.${index}.name`}
                                        className="ceinputfield"
                                        placeholder="Enter wild card name"
                                        value={values?.wildCard?.[index]?.name || ""}
                                        onChange={(e) =>
                                          setFieldValue(`wildCard.${index}.name`, e.target.value)
                                        }
                                        onBlur={() =>
                                          setFieldTouched(`wildCard.${index}.name`, true)
                                        }
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                      className="profileItems"
                                      help={errors?.wildCard?.[index]?.registrationFee}
                                      validateStatus={
                                        errors?.wildCard?.[index]?.registrationFee
                                          ? "error"
                                          : "success"
                                      }
                                      style={{ marginBottom: "16px" }}>
                                      <label className="boldlabel">Entry Fee</label>
                                      <InputNumber
                                        name={`wildCard.${index}.registrationFee`}
                                        className="ceinputfield"
                                        placeholder="0"
                                        style={{ width: "100%" }}
                                        min={0}
                                        value={values?.wildCard?.[index]?.registrationFee}
                                        onChange={(value) =>
                                          setFieldValue(`wildCard.${index}.registrationFee`, value)
                                        }
                                        onBlur={() =>
                                          setFieldTouched(`wildCard.${index}.registrationFee`, true)
                                        }
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                      className="profileItems"
                                      help={errors?.wildCard?.[index]?.noOfSlots}
                                      validateStatus={
                                        errors?.wildCard?.[index]?.noOfSlots ? "error" : "success"
                                      }
                                      style={{ marginBottom: "16px" }}>
                                      <label className="boldlabel">No of Slots</label>
                                      <InputNumber
                                        name={`wildCard.${index}.noOfSlots`}
                                        className="ceinputfield"
                                        placeholder="1"
                                        style={{ width: "100%" }}
                                        min={1}
                                        value={values?.wildCard?.[index]?.noOfSlots}
                                        onChange={(value) =>
                                          setFieldValue(`wildCard.${index}.noOfSlots`, value)
                                        }
                                        onBlur={() =>
                                          setFieldTouched(`wildCard.${index}.noOfSlots`, true)
                                        }
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col xs={24} sm={12} md={4}>
                                    <Form.Item style={{ marginBottom: "16px" }}>
                                      <label
                                        className="boldlabel"
                                        style={{ visibility: "hidden", height: "38px" }}>
                                        Action
                                      </label>
                                      <div>
                                        <Button
                                          danger
                                          type="primary"
                                          icon={<MdDelete />}
                                          size="middle"
                                          onClick={() => {
                                            if (values?.wildCard?.[index]?._id) {
                                              arrayHelpers.replace(index, {
                                                ...values.wildCard[index],
                                                isDeleted: true
                                              });
                                            } else {
                                              arrayHelpers.remove(index);
                                            }
                                          }}
                                        />
                                      </div>
                                    </Form.Item>
                                  </Col>
                                </Row>
                              </div>
                            );
                          })}

                        <Button
                          type="dashed"
                          onClick={() => arrayHelpers.push(data)}
                          style={{
                            width: "100%",
                            marginTop: "8px",
                            borderStyle: "dashed",
                            borderColor: "#d9d9d9"
                          }}
                          size="large">
                          + Add Wild Card Entry
                        </Button>
                      </div>
                    )}
                  />
                </Form.Item>
              )}
            </>
          )}
        </Col>
      </Row>

      {/* Choose Awards */}
      {awardsOpen && (
        <ChooseAwardsModal
          values={values}
          error={errors}
          open={awardsOpen}
          setOpen={setAwardsOpen}
          setFieldValue={setFieldValue}
          sportAwards={sportAwards}
          setSportAwards={setSportAwards}
        />
      )}

      {/* Panel Modal */}
      {panelModal && (
        <ChoosePanelModal
          open={panelModal}
          setOpen={setPanelModal}
          setFieldValue={setFieldValue}
          panels={panels}
          values={values}
        />
      )}
    </>
  );
}

export default Page1;
